<template>
    <div class="menu_couriers__list">
        <div v-if="!isCouriersList" class="menu_couriers__list_container" :class="classNoOrders">
            <div class="menu_couriers__list_no_couriers">
                {{ __t('O.NO_OPEN_ORDERS') }}
            </div>
        </div>
        <div v-if="isCouriersList" class="menu_couriers__list_container">
            <menu_couriers_list
                :key="'menu_couriers_list_new'"
                :titleList="'Нові'"
                :listCouriers="ordersList"
            />
        </div>
    </div>
</template>

<script>

import menu_couriers_switch from "././MenuCouriersSwitch.vue";
import menu_couriers_list from "./MenuCouriersList.vue";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "menu_couriers",
    props: {},
    components: {
        menu_couriers_switch,
        menu_couriers_list
    },
    mixins: [screenSize],
    data() {
        return {
            isActiveSwitch: true,
        }
    },
    methods: {
        clickSwitchButton(activeCouriersSwitch) {
            if (activeCouriersSwitch) {
                this.isActiveSwitch = true;
                return;
            }
            this.isActiveSwitch = false;
        },
        clickCreateOrder(){
            this.$router.push({path: "/new"});
        }
    },
    computed: {
        ...mCouriers([
            'ordersPos',
            'countAllCouriers',
            'activeCourierOrder',
        ]),
        isCouriersList() {
            if (this.ordersPos.data.length > 0) {
                return true;
            }
            return false;
        },
        ordersList() {
            if(this.ordersPos && this.ordersPos.data) {
                return this.ordersPos.data;
            }
            return [];
        }
    },
}
</script>
